import { Text } from 'app/design/primitives/text';
import type {
  ConciergeMessage,
  LoanMessage,
  RecomMessage,
  SystemMessage,
  TextMessage,
  UnavailabilityMessage,
} from 'app/types/chat';
import { THUMBS_UP } from 'app/network/chat/message';
import { isSystemMessage } from 'app/types/chat';
import { Hyperlink } from 'react-native-hyperlink';
import type { ColorValue } from 'react-native';
import { Trans } from 'react-i18next';

interface UserMessageProps {
  isAuthor: boolean;
  message: TextMessage | LoanMessage | SystemMessage | RecomMessage | ConciergeMessage | UnavailabilityMessage;
  textColor: ColorValue;
}

export function UserMessage({ isAuthor, message, textColor }: UserMessageProps) {
  return (
    <Hyperlink linkDefault linkStyle={{ textDecorationLine: 'underline' }}>
      <Text
        fontSize={message.message === THUMBS_UP ? 30 : 16}
        style={{ color: textColor, fontStyle: isSystemMessage(message) ? 'italic' : undefined }}
        textAlign={isAuthor && message.message === THUMBS_UP ? 'right' : undefined}
        variant="bodyBase"
      >
        {typeof message.message === 'string' ? (
          message.message
        ) : (
          <Trans
            components={{ strong: <Text fontWeight="700" /> }}
            i18nKey={message.message.i18nKey}
            ns={message.message.ns}
            values={message.message.values}
          />
        )}
      </Text>
    </Hyperlink>
  );
}
